export const ORGANIC_PROVIDER = 'Organic';

export enum EMMA_PROVIDER_META {
  FACEBOOK = 'facebook',
  GOOGLE_ADS = 'googleAds',
  APPLE_SEARCH_ADS = 'appleSearchAds',
  SNAPCHAT = 'snapchat',
  REDDIT = 'reddit',
  TIKTOK = 'tiktok',
  TIKTOK_SAN = 'tiktokSan',
  TINDER = 'tinder',
  TWITTER = 'twitter',
  PETAL_ADS = 'petalAds',
  TTD = 'theTradeDesk',
  MICROSOFT_ADS = 'microsoftAds',
  AMAZON_ADS = 'amazonAds',
}

export enum EMMA_PROVIDER_TYPE {
  INBOUND = 'inbound',
  CUSTOM = 'custom',
  AD_NETWORK = 'adnetwork',
  RETARGETING = 'retargeting',
  AGENCY = 'agency',
  AUTO = 'auto',
}

/** Providers SAN that can create apptracker networks automatically. */
export const SAN_PROVIDER_METAS: EMMA_PROVIDER_META[] = [
  EMMA_PROVIDER_META.FACEBOOK,
  EMMA_PROVIDER_META.GOOGLE_ADS,
  EMMA_PROVIDER_META.APPLE_SEARCH_ADS,
  EMMA_PROVIDER_META.SNAPCHAT,
  EMMA_PROVIDER_META.REDDIT,
  EMMA_PROVIDER_META.TIKTOK,
  EMMA_PROVIDER_META.TIKTOK_SAN,
  EMMA_PROVIDER_META.TWITTER,
  EMMA_PROVIDER_META.PETAL_ADS,
  EMMA_PROVIDER_META.MICROSOFT_ADS,
  EMMA_PROVIDER_META.AMAZON_ADS,
];

export enum EMMA_POSTBACK_PARAMS {
  aaid = 'aaid',
  cid = 'cid',
  event_id = 'event_id',
  idfa = 'idfa',
  idfv = 'idfv',
  p1 = 'p1',
  p2 = 'p2',
  p3 = 'p3',
  p4 = 'p4',
  p5 = 'p5',
  p6 = 'p6',
  p7 = 'p7',
  p8 = 'p8',
  p9 = 'p9',
  referrer = 'referrer',
  sid = 'sid',
  tid = 'tid',
}

export enum EMMA_POSTBACK_MACROS {
  aaid = 'aaid',
  carrier = 'carrier',
  city = 'city',
  country = 'country',
  device = 'device',
  event_id = 'event_id',
  event_name = 'event_name',
  idfa = 'idfa',
  idfv = 'idfv',
  install_unixts = 'install_unixts',
  ip = 'ip',
  language = 'language',
  match_type = 'match_type',
  os = 'os',
  os_v = 'os_v',
  referrer = 'referrer',
  sdk_v = 'sdk_v',
  user_agent = 'user_agent',
  user_id = 'user_id',
  uuid = 'uuid',
  uuid_type = 'uuid_type',
  wifi = 'wifi',
  // em_cid = 'em_cid',
  // em_tid = 'em_tid',
  // em_sid = 'em_sid',
  // em_p1 = 'em_p1',
  // em_p2 = 'em_p2',
  // em_p3 = 'em_p3',
  // em_p4 = 'em_p4',
  // em_p5 = 'em_p5',
  // em_p6 = 'em_p6',
  // em_p7 = 'em_p7',
  // em_p8 = 'em_p8',
  // em_p9 = 'em_p9',
}

export const DEFAULT_NOTIFICATION_EVENT_WINDOW = 168;
export const DEFAULT_ATTRIBUTION_CLICK_WINDOW = 720;
export const DEFAULT_ATTRIBUTION_IMPRESSION_WINDOW = 24;
export const DISABLED_ATTRIBUTION_IMPRESSION_WINDOW = -1;
export const DEFAULT_RETARGETING_ATTRIBUTION_CLICK_WINDOW = 720;

export enum EMMA_LEGACY_POSTBACK_PARAMS {
  EXID = 'exid',
  CAMID = 'camid',
  APP_NAME = 'app_name',
  APP_CATS = 'app_cats',
  DP = 'dp',

  UDID = 'udid',
  UDID_MD5 = 'udid_md5',
  IP = 'ip',
  DEVICE = 'device',
  COUNTRY = 'country',
  CUSTOMER_ID = 'customer_id',
  USER_ID = 'user_id',

  CLICK_ID = 'click_id',
  CAMPAIGN_ID = 'campaign_id',
  NETWORK_ID = 'network_id',
  PROVIDER_ID = 'provider_id',
  ORDER_ID = 'order_id',
  AMOUNT = 'amount',

  RANDOM = 'random',
  UNIX_TIME = 'unix_time',

  EAT_SUB1 = 'eat_sub1',
  EAT_SUB2 = 'eat_sub2',
  EAT_SUB3 = 'eat_sub3',
  EAT_SUB4 = 'eat_sub4',
  EAT_SUB5 = 'eat_sub5',
  EAT_SUB6 = 'eat_sub6',
  EAT_SUB7 = 'eat_sub7',
  EAT_SUB8 = 'eat_sub8',
  EAT_SUB9 = 'eat_sub9',
  EAT_SUB10 = 'eat_sub10',
  EAT_SUB11 = 'eat_sub11',
  EAT_SUB12 = 'eat_sub12',
  EAT_SUB13 = 'eat_sub13',
  EAT_SUB14 = 'eat_sub14',
  EAT_SUB15 = 'eat_sub15',
  EAT_SUB16 = 'eat_sub16',
  EAT_SUB17 = 'eat_sub17',
  EAT_SUB18 = 'eat_sub18',
  EAT_SUB19 = 'eat_sub19',
  EAT_SUB20 = 'eat_sub20',
  EAT_SUB21 = 'eat_sub21',
  EAT_SUB22 = 'eat_sub22',
  EAT_SUB23 = 'eat_sub23',
  EAT_SUB24 = 'eat_sub24',
  EAT_SUB25 = 'eat_sub25',
}

export const PROVIDERS_WITH_ATTRIBUTION_IMPRESSION_WINDOW = [
  EMMA_PROVIDER_META.GOOGLE_ADS,
  EMMA_PROVIDER_META.FACEBOOK,
  EMMA_PROVIDER_META.REDDIT,
  EMMA_PROVIDER_META.TIKTOK,
  EMMA_PROVIDER_META.TIKTOK_SAN,
  EMMA_PROVIDER_META.TWITTER,
  EMMA_PROVIDER_META.SNAPCHAT,
  EMMA_PROVIDER_META.APPLE_SEARCH_ADS,
  EMMA_PROVIDER_META.PETAL_ADS,
  EMMA_PROVIDER_META.AMAZON_ADS,
];
